import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CallbackPopup from './CallbackPopup';

const treatments = [
  { name: "Liver Transplant", slug: "liver-transplant" },
  { name: "Kidney Transplant", slug: "kidney-transplant" },
  { name: "Bone Marrow Transplant", slug: "bone-marrow-transplant" },
  { name: "Lung Cancer Treatment", slug: "lung-cancer-treatment" },
  { name: "Lung Transplant", slug: "lung-transplant" },
  { name: "Heart Transplant", slug: "heart-transplant" },
];
// Doctor and hospital data with IDs for linking
const topDoctors = [
  { id: "dr-vivek-vij", name: "Dr. Vivek Vij" },
  { id: "dr-sandeep-vaishya", name: "Dr. Sandeep Vaishya" },
  { id: "dr-dharma-choudhary", name: "Dr. Dharma Choudhary" },
  { id: "dr-rana-patir", name: "Dr. Rana Patir" },
  { id: "dr-lohith-reddy", name: "Dr. Lohith Reddy" },
  { id: "dr-ips-oberoi", name: "Dr. IPS Oberoi" },
];
const topHospitals = [
  { id: "max-hospital-gurugram", name: "Max Hospital, Gurugram" },
  { id: "medicana-international", name: "Medicana International" },
  { id: "liv-hospital-istanbul", name: "LIV Hospital, Istanbul" },
  { id: "fortis-hospital-noida", name: "Fortis Hospital, Noida" },
  { id: "apollo-hospitals-greams-road-chennai", name: "Apollo Hospitals, Greams Road, Chennai" },
  { id: "nanavati-max-super-speciality-hospital-mumbai", name: "Nanavati Max Super Speciality Hospital, Mumbai" },
];
const navLinks = [
  { label: "About us", to: "/about" },
  { label: "Contact us", to: "/contactus" },
  { label: "For Hospitals", to: "/hospitals" },
  { label: "For Medical Tourism Companies", to: "/contactus#get-in-touch" },
  { label: "For Testing Labs", to: "/contactus#get-in-touch" },
  { label: "Medical Destinations", to: "/contactus#get-in-touch" },
];

const Footer = () => {
  const navigate = useNavigate();
  const [isCallbackOpen, setIsCallbackOpen] = useState(false);

  return (
    <footer className="bg-[#f7fafd] text-[#222] pt-16 pb-6 border-t border-gray-200 mt-10">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-8 border-b border-gray-200 pb-12">
          {/* Left: Logo & Contact */}
          <div className="flex-1 min-w-[220px] flex flex-col items-start mb-6 md:mb-0">
            <img
              src="/images/medical-likers-logo.png"
              alt="Medical Linkers Logo"
              className="h-12 mb-3"
            />
            <a
              href="mailto:info@medicallinkers.com"
              className="text-sm mb-4 text-[#222]"
            >
              info@medicallinkers.com
            </a>
            <div className="flex space-x-6 mb-2">
              <a
                href="https://www.instagram.com/medicallinkers/"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500"
              >
                <i className="fab fa-instagram text-2xl md:text-3xl"></i>
              </a>
              <a
                href="https://www.facebook.com/medicallinkers"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500"
              >
                <i className="fab fa-facebook text-2xl md:text-3xl"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/sonam-garg-sharma/"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500"
              >
                <i className="fab fa-linkedin text-2xl md:text-3xl"></i>
              </a>
            </div>
          </div>
          {/* Treatments */}
          <div className="flex-1 min-w-[180px] mb-6 md:mb-0">
            <h4 className="font-semibold mb-3">Treatments</h4>
            <ul className="text-sm space-y-1 font-bold">
              {treatments.map((t) => (
                <li key={t.name}>
                  &#8250;{" "}
                  <Link
                    to={`/treatments/${t.slug}`}
                    className="hover:underline hover:text-blue-500"
                  >
                    {t.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          {/* Top Doctors */}
          <div className="flex-1 min-w-[180px] mb-6 md:mb-0">
            <h4 className="font-semibold mb-3">Top Doctors</h4>
            <ul className="text-sm space-y-1 font-bold">
              {topDoctors.map((d) => (
                <li key={d.name}>
                  &#8250;{" "}
                  <Link
                    to={`/doctor-details/${d.id}`}
                    className="hover:underline"
                  >
                    {d.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          {/* Top Hospitals */}
          <div className="flex-1 min-w-[180px] mb-6 md:mb-0">
            <h4 className="font-semibold mb-3">
              <Link to="/hospitals" className="hover:underline">
                Top Hospitals
              </Link>
            </h4>
            <ul className="text-sm space-y-1 font-bold">
              {topHospitals.map((h) => (
                <li key={h.name}>
                  &#8250;{" "}
                  <Link to={`/hospital/${h.id}`} className="hover:underline">
                    {h.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        {/* Buttons Row */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 py-6">
          <button
            onClick={() => setIsCallbackOpen(true)}
            className="bg-[#1976d2] text-white px-6 py-2 rounded-full font-semibold hover:bg-[#125ea2] transition flex items-center justify-center gap-2 w-48 h-12"
          >
            Get A Call Back
          </button>
          <a
            href="https://api.whatsapp.com/send/?phone=9599222655&text=Hello%2C+please+contact+me+regarding+https%3A%2F%2Fwww.medicallinkers.org%2Fhospitals%2F+%2C+Thank+you%21&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#1976d2] text-white px-6 py-2 rounded-full font-semibold hover:bg-[#125ea2] transition flex items-center justify-center gap-2 w-48 h-12"
          >
            <i className="fab fa-whatsapp text-2xl"></i>
            Contact Us
          </a>
          <button
            className="border border-[#1976d2] text-[#1976d2] px-6 py-2 rounded-full font-semibold hover:bg-[#e3f0fc] transition flex items-center justify-center w-48 h-12"
            onClick={() => navigate("/donation")}
          >
            Donate For Care
          </button>
        </div>
        {/* Navigation Links */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-[#222] mb-2 font-bold">
          {navLinks.map((link) =>
            link.to.startsWith("/") ? (
              <Link key={link.label} to={link.to} className="hover:underline">
                {link.label}
              </Link>
            ) : (
              <a key={link.label} href={link.to} className="hover:underline">
                {link.label}
              </a>
            )
          )}
        </div>
        {/* Copyright & Policies */}
        <div className="text-center text-xs text-gray-500 mt-2">
          <span>
            © 2025 Medical Linkers(TM) a unit of AS Medical Linkers LLP
          </span>{" "}
          &nbsp;|&nbsp;
          <Link to="/privacy" className="hover:underline">
            Privacy Policy
          </Link>{" "}
          &nbsp;|&nbsp;
          <Link to="/termsandservice" className="hover:underline">
            Terms of Service
          </Link>
        </div>
      </div>

      {/* Callback Popup */}
      <CallbackPopup 
        isOpen={isCallbackOpen}
        onClose={() => setIsCallbackOpen(false)}
      />
    </footer>
  );
};

export default Footer;
